import { getFetch, postFetchWithBody, postFetchWithToken } from "../../utils/fetch";

async function getPurchasor(page, term = "") {
    const data = await getFetch(`/Purchasor?page=${page}&term=${term}`);
    if (data.status !== "error") {
        return {
            status: "success",
            message: data,
        };
    } else {
        return {
            status: data.status,
            message: "خطا در اتصال به سرور!",
        };
    }
}

async function updatePurchasor(form) {
    if (!form.id) {
        return {
            status: 'error',
            message: 'شناسه مشتری نامشخص است!',
        };
    }

    const res = await postFetchWithBody("/Purchasor/update", form);
    if (res.status !== 'error') {
        return {
            status: 'success',
            message: 'مشتری با موفقیت ویرایش شد',
        };
    } else {
        return {
            status: res.status,
            message: res.message,
        };
    }
}

async function deletePurchasor(id) {
    const res = await postFetchWithBody(`/Purchasor/destroy`, { id: id });
    if (res.status !== "error") {
        return {
            status: "success",
            message: res,
        };
    } else {
        return {
            status: res.status,
            message: "خطا در اتصال به سرور!",
        };
    }
}

async function storePurchasor(form) {
    if (form.get("name") === "") {
        return {
            status: "error",
            message: "نام و نام خانوادگی الزامی است!",
        };
    }

    const res = await postFetchWithToken("/Purchasor/store", form);
    if (res.status !== "error") {
        return {
            status: "success",
            message: "مشتری با موفقیت ایجاد شد",
        };
    } else {
        return {
            status: res.status,
            message: res.message,
        };
    }
}

export { getPurchasor ,deletePurchasor , storePurchasor, updatePurchasor };
